export const getBreadcrumbItems = (additionalItems = []) => [
  { path: '/sg/en', label: 'Homepage' },
  { path: '/sg/en/services', label: 'Services' },
  ...additionalItems,
];

export const getCurrentPath = (additionalPath = '') => `/sg/en/services${additionalPath}`;
